<div class="block block-themed block-transparent mb-0">
    <div class="block-header bg-primary-dark">
        <h3 class="block-title">Import statistics</h3>
        <div class="block-options">
            <button
                type="button"
                class="btn-block-option"
                data-dismiss="modal"
                aria-label="Close"
                (click)="close()"
            >
                <i class="si si-close"></i>
            </button>
        </div>
    </div>
    <div class="block-content">
        <table class="table table-bordered table-striped table-vcenter">
            <tbody>
                <tr>
                    <th>Total Housings</th>
                    <td>{{ stats.housingsTotal }}</td>
                </tr>
                <tr>
                    <th>Housings before merge</th>
                    <td>{{ stats.housingsBeforeMerge }}</td>
                </tr>
                <tr>
                    <th>New housings</th>
                    <td>{{ stats.newHousings }}</td>
                </tr>
                <tr>
                    <th>New housings (&gt;50 rooms)</th>
                    <td>{{ stats.newHousingsWithGte50Rooms }}</td>
                </tr>
                <tr>
                    <th>Updated housings</th>
                    <td>{{ stats.updatedHousings }}</td>
                </tr>
                <tr>
                    <th>Updated housings received trivago id</th>
                    <td>{{ stats.updatedHousingsReceivedTrivagoId }}</td>
                </tr>
                <tr>
                    <th>Housings with trivago id</th>
                    <td>{{ stats.housingsWithTrivagoId }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div class="modal-footer">
    <button
        type="button"
        class="btn btn-alt-secondary"
        data-dismiss="modal"
        (click)="close()"
    >
        Close
    </button>
</div>
